import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  usuarios: {
    id: number;
    nome: string;
    nivel: string;
    email: string;
    telefone: string;
    cpf: string;
    cnpj: string;
    status: string;
    ultimo_login: string;
  }[];
}

// tipagem do que o hook retorna
export type IReponse = IResponseData['usuarios'];

async function getParceirosAbaixo(): Promise<IReponse> {
  const response = await backend.get<IResponseData>(`/parceiros-abaixo`);
  return response.data.usuarios;
}

export function useParceirosAbaixo() {
  return useQuery(['parceiros-abaixo'], () => getParceirosAbaixo(), {
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
